<template>
  <nuttrema-layout-form-standard :edit="true" :theme="theme">
    <template slot="center">

      <el-form
         label-width="25%"
        :ref="formRef"
        :rules="rules"
        :model="formData"
        :label-position="labelPosition">

        <section>
          <el-row type="flex" justify="center">
            <el-col :xs="24" :md="18">
              <nuttrema-jumbotron>
                <h1>{{ $t('label.set_new_password') }}</h1>
                <h4>{{ $t('label.type_in_your_email_and_choose_new_password') }}</h4>
              </nuttrema-jumbotron>
            </el-col>
          </el-row>

          <el-row v-if="_get(AuthenticationResetPassword, 'saveError')" type="flex" justify="center">
            <el-col :xs="24" :md="12">
              <nuttrema-form-alert
                 type="pink"
                 icon="far fa-exclamation"
                 icon-class-name="is-error"
                 title="Hm, there is a problem"
                :error="_get(AuthenticationResetPassword, 'saveError')"
                :text="_get(AuthenticationResetPassword, 'saveError')">
              </nuttrema-form-alert>
            </el-col>
          </el-row>

          <div class="section-items">
            <el-form-item :label="$t('label.password')" prop="password">
              <el-col :xs="24" :md="16">
                <nuttrema-password-input v-model="formData.password"></nuttrema-password-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.confirm_password')" prop="confirm_password">
              <el-col :xs="24" :md="16">
                <nuttrema-password-input v-model="formData.confirm_password"></nuttrema-password-input>
              </el-col>
            </el-form-item>

            <el-form-item>
              <el-col :xs="24" :md="16">
                <el-button
                   type="nuttrema-dark-gray"
                   class="w-100"
                  :loading="isSaving"
                  @click="submitForm">
                  {{ $t('label.reset_password') }}
                </el-button>
              </el-col>
            </el-form-item>
          </div>

        </section>
      </el-form>

    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import NuttremaNotification from 'components/ui/alert/nuttrema-notification';
import NuttremaFormAlert from 'components/ui/alert/nuttrema-form-alert';

import NuttremaJumbotron from 'components/ui/panels/nuttrema-jumbotron';

import NuttremaPasswordInput from 'components/ui/input/nuttrema-password-input';

export default {
  name: 'form-reset-password',
  mixins: [FormStandardBehavior],
  props: {
    theme: {
      type: String,
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    AuthenticationResetPassword: {
      required: false,
      default: null,
    },
    token: {
      type: String,
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaJumbotron,
    NuttremaFormAlert,
    NuttremaNotification,
    NuttremaPasswordInput,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        token: null,
        password: null,
        confirm_password: null,
      },
      rules: {
        password: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.password', true),
          },
          {
            min: 8,
            max: 72,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.password_length'),
          },
        ],
        confirm_password: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.confirm_password', true),
          },
          {
            min: 8,
            max: 72,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.password_length'),
          },
          {
            trigger: 'blur',
            validator: this.validatePassword,
            message: this.formatValidationMessage('validation.confirm_password_not_match'),
          },
        ],
      },
    };
  },
  methods: {
    validatePassword(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.formData.password) {
        callback(new Error('Confirm password should be same as new password!'));
      } else {
        callback();
      }
    },
    getFormData() {
      return this.clone(this.formData);
    },
    setFormData() {
      this.formData.token = this.token;
    },
  },
  created() {
    this.formRef = 'form-reset-password';
    this.stateData = this.AuthenticationResetPassword;
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/shared/reset-password/form-reset-password.vue